import React from 'react';
import {map} from 'lodash';
import StatisticsTable from './statistics-table';

interface Props {
  college: {
    majors?: {
      name: string;
      highlighted: boolean;
      percent: number;
    }[];
  };
}

const PopularMajorsTable = ({college}: Props) => {
  const getRows = () => {
    const {majors} = college;

    if (majors) {
      return map(majors, (major) => ({
        name: major.name,
        highlighted: !!major.highlighted,
        values: [`${major.percent.toFixed(1)}%`],
      }));
    }

    return [];
  };

  const rows = getRows();
  return <StatisticsTable caption="Popular Majors" rows={rows} />;
};

export default PopularMajorsTable;
